module.exports = __webpack_public_path__ + "static/media/zip.b1032828.svg";